import { cssProperty } from '../utils/cssProperties.js';
import { css, styled } from 'styled-components';
import { componentBaseConfig } from '../styled-components/componentBaseConfig.js';
import { isDefined } from '@fabric-app/utils/guards';
import { mediaMobile } from '../constants/styled-utils.js';

const gaps = {
  /**
  * usually for container for text elements
  */
  text: css([
    `gap:0.25rem;`
  ]),
  /**
  * small element with flexbox, such as button with text and icon
  */
  element: css([
    `gap:0.5rem;`
  ]),
  /**
  * small element with flexbox, such as button with text and icon
  */
  6: css([
    `gap:0.375rem;`
  ]),
  /**
  * small element with flexbox, such as button with text and icon
  */
  10: css([
    `gap:0.625rem;`
  ]),
  /**
  * small element with flexbox, such as button with text and icon
  */
  12: css([
    `gap:0.75rem;`
  ]),
  /**
  * e.g. element with text and buttons with a slightly bigger gap
  */
  24: css([
    `gap:1.5rem;`
  ]),
  /**
  * examples:
  * - container with large icon or avatar and text
  * - resource tile list
  */
  elementsContainer: css([
    `gap:1rem;`
  ]),
  /**
  * e.g. container of page sections
  */
  sections: css([
    `gap:1.875rem;`
  ]),
  /**
  * e.g. container of bigger boxed elements which are placed visually closer together
  */
  sectionsShort: css([
    `gap:1.25rem;`
  ]),
  /**
  * e.g. container of page sections with larger gap to visually clearly separate each block
  * The gap is shorter on mobile to avoid too much empty vertical space compared to the horizontal white spacing
  */
  sectionsLarge: css([
    `gap:4rem;`,
    `{gap:3rem;}`
  ], mediaMobile),
  60: css([
    `gap:3.75rem;`
  ]),
  /**
  * e.g. container of page sections with a medium gap to visually separate each block
  */
  sectionsMedium: css([
    `gap:2.5rem;`
  ]),
  none: css([
    `gap:0;`
  ])
};
const Flex = styled.div.withConfig(componentBaseConfig).withConfig({
  displayName: "Flex",
  componentId: "sc-91b2249a-0"
})([
  `display:flex;`,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ` `,
  ``
], (p) => css([
  `flex-direction:`,
  `;`,
  `;`
], p.direction || "row", typeof p.gap === "number" ? `gap: ${p.gap}px;` : p.gap && gaps[p.gap]), (p) => p.alignItems && `align-items: ${p.alignItems};`, (p) => p.justifyContent && `justify-content: ${p.justifyContent};`, (p) => p.flexWrap && `flex-wrap: ${p.flexWrap};`, (p) => p.textAlign && `text-align: ${p.textAlign};`, (p) => isDefined(p.flexGrow) && `flex-grow: ${typeof p.flexGrow === "boolean" ? 1 : p.flexGrow};`, (p) => isDefined(p.flexShrink) && `flex-shrink: ${typeof p.flexShrink === "boolean" ? p.flexShrink ? 1 : 0 : p.flexShrink};`, (p) => isDefined(p.maxWidth) && cssProperty("max-width", p.maxWidth), (p) => isDefined(p.maxHeight) && cssProperty("max-height", p.maxHeight), (p) => p.overflow && `overflow: ${p.overflow};`, (p) => isDefined(p.minWidth) && cssProperty("min-width", p.minWidth), (p) => isDefined(p.minHeight) && cssProperty("min-height", p.minHeight));

export { Flex };
//# sourceMappingURL=Flex.js.map
